import React, { useMemo, useState } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { NEWS_ITEMS } from "./newsData";

const CalyxSolutionsStandsforMigrantCommunitiesattheFCAMeeting = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText =
    "Calyx Solutions Stands for Migrant Communities at the/nFCA Meeting";

  const title =
    "Calyx Solutions Stands for Migrant Communities at the/nFCA Meeting";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  // Sidebar state: search and filtered latest news (exclude current article)
  const currentSlug = "calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting";
  const [term, setTerm] = useState("");
  const latestNews = useMemo(() => {
    return NEWS_ITEMS
      .filter((n) => n.slug !== currentSlug)
      .filter((n) => (n.title || "").toLowerCase().includes(term.toLowerCase()))
      .slice(0, 10);
  }, [term]);
  return (
    <>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>
          Calyx Solutions Stands for Migrant Communities at the FCA Meeting
        </title>
        <meta
          name="description"
          content="At Calyx Solutions, we remain committed to addressing the challenges faced by high-risk and underserved communities, including migrant communities. We recently had the opportunity to represent these communities at a meeting with the Financial Conduct Authority (FCA) to discuss the barriers they face in accessing financial services."
        />
        {/* Use relative canonical during local dev to avoid cross-origin redirects */}
        <link
          rel="canonical"
          href="/news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting"
        />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Calyx Solutions Stands for Migrant Communities at the FCA Meeting"
        />
        <meta
          property="og:description"
          content="At Calyx Solutions, we remain committed to addressing the challenges faced by high-risk and underserved communities, including migrant communities. We recently had the opportunity to represent these communities at a meeting with the Financial Conduct Authority (FCA) to discuss the barriers they face in accessing financial services."
        />
        {/* Avoid absolute URL locally to prevent redirect loops */}
        <meta
          property="og:url"
          content="/news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting"
        />
        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting.jpg"
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Calyx Solutions Stands for Migrant Communities at the FCA Meeting"
        />
        <meta
          name="twitter:description"
          content="At Calyx Solutions, we remain committed to addressing the challenges faced by high-risk and underserved communities, including migrant communities. We recently had the opportunity to represent these communities at a meeting with the Financial Conduct Authority (FCA) to discuss the barriers they face in accessing financial services."
        />
        <meta
          name="twitter:image"
          content="https://msbassociationuk.org/assets/images/news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting.jpg"
        />
      </Helmet>
      <style>{`
        .news-hero { width: 100%; height: auto; border-radius: 0.5rem; }
        .news-meta { color: #adb5bd; font-size: 0.9rem; margin-top: 0.5rem; }
        .news-quote { position: relative; background: #2f2f2f; color: #e9ecef; padding: 1.25rem 1.25rem 1.25rem 2.75rem; border-left: 4px solid #fba834; border-radius: 0.5rem; margin: 1.25rem 0; font-style: italic; overflow: hidden; }
        .news-cta { display: inline-block; margin-top: 0.75rem; }
        .latest-news a { text-decoration: none; }
      `}</style>
      <main className="page_content">

        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <h1 className="page_title text-white">
              Calyx Solutions Stands for Migrant Communities at the FCA
              Meeting
            </h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/news">News</NavLink>
              </li>
              <li className="active">
                <a href="#!">
                  Calyx Solutions Stands for Migrant Communities at the FCA
                  Meeting
                </a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row g-4">
              <div className="col-12 col-lg-8">
                <div className="item_details_content p-3">
                  <img
                    className="news-hero"
                    src="/assets/images/news/calyx-solutions-stands-for-migrant-communities-at-the-fca-meeting.jpg"
                    alt="Calyx Solutions Stands for Migrant Communities at the FCA Meeting"
                  />
                  <h3 className="mt-4 mb-1">Calyx Solutions Stands for Migrant Communities at the FCA Meeting</h3>
                  <div className="news-meta">Published: 14 Oct 2025</div>

                  <p className="mt-4 mb-2">
                    At <strong>Calyx Solutions</strong>, we remain committed to addressing the
                    challenges faced by high-risk and migrant communities across the UK. Many
                    individuals in these communities rely on <strong>remittance services</strong> to
                    support their families abroad — often in fragile or high‑risk regions such as
                    Afghanistan.
                  </p>
                  <p className="mb-2">
                    Recognising these ongoing challenges, <strong>Mr. Vishal Patil, Chairman of MSB
                      Association</strong>, represented the community’s voice at the <strong>Financial
                        Conduct Authority (FCA) Annual Public Meeting</strong> on <strong>9th October 2025</strong>.
                    During the session, Mr. Vishal raised an important question highlighting the real
                    difficulties faced by customers who depend on money transfer services:
                  </p>

                  <blockquote className="news-quote">
                    Many migrant communities in the UK rely on remittances to support their
                    families abroad, often in high‑risk or fragile states such as Afghanistan. Current
                    regulatory restrictions mean that, in some cases, the only way for them to send
                    money is in cash through limited physical agents. If a customer lives in the
                    countryside or outside a major UK city, they may have no access to digital
                    remittance apps — or where such apps exist, reduced competition often leads to
                    higher fees and poor exchange rates. Is regulation unintentionally making these
                    communities more vulnerable by restricting access to affordable digital money
                    transfer services? And what steps will the FCA take to ensure fair access,
                    innovation, and equal opportunity for customers who simply want to support their
                    families back home?
                  </blockquote>

                  <div className="text-center">
                    <NavLink className="btn bg-primary text-dark" to="https://youtu.be/LvqiWfk74x0?si=PFWAO7cEmxIPvT4V" target="_blank">
                      <i className="fa-brands fa-youtube me-2 fa-2x" />Click here to watch the FCA’s response
                    </NavLink>
                  </div>

                  <p className="mt-4 mb-2">
                    While the FCA’s reply was polite yet general, it did not fully address the
                    concerns raised. Nonetheless, this moment marked a <strong>significant step forward</strong>,
                    underscoring the importance of <strong>continued advocacy, dialogue, and
                      collaboration</strong> to achieve meaningful progress.
                  </p>
                  <p className="mb-4">
                    At Calyx Solutions, we firmly believe that <strong>every customer — regardless of
                      location or background — deserves access to affordable, safe, and inclusive
                      financial services</strong>.
                  </p>

                  <img
                    className="news-hero"
                    src="/assets/images/news/FCA-Meeting-sub-banner-two.png"
                    alt="Calyx Solutions Stands for Migrant Communities at the FCA Meeting"
                  />
                </div>
              </div> 

              <div className="col-12 col-lg-4">
                <aside className="p-3 rounded-3" style={{ background: "#f8f9fa" }}>
                  <h5 className="text-dark mb-3">Latest News</h5>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search news..."
                      value={term}
                      onChange={(e) => setTerm(e.target.value)}
                      aria-label="Search news"
                    />
                  </div>
                  <ul className="list-unstyled latest-news m-0">
                    {latestNews.length === 0 && (
                      <li className="text-muted">No results</li>
                    )}
                    {latestNews.map((item) => (
                      <li key={item.slug} className="mb-3">
                        <NavLink to={`/news/${item.slug || ""}`} className="d-block">
                          <div className="fw-semibold text-dark lh-sm">{item.title}</div>
                          {item.date && (
                            <small className="text-muted">
                              {new Date(item.date).toLocaleDateString("en-GB", { year: "numeric", month: "short", day: "2-digit" })}
                            </small>
                          )}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                  <div className="d-flex justify-content-center mt-3">
                    <NavLink to="/news" className="btn bg-primary text-dark">All News</NavLink>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default CalyxSolutionsStandsforMigrantCommunitiesattheFCAMeeting;
